import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SecurityService, WorkflowContextService } from 'src/app/services';
import { Role } from 'src/app/models';
import {
  InviteUserRequest,
  InviteUserResponse
} from 'src/app/models/invited-user';
import { CommonConfirmationModalData } from
  'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';

@Component({
  selector: 'wm-users-invite',
  standalone: false,
  templateUrl: './users-invite-janus.component.html',
  styleUrls: ['./users-invite-janus.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UsersInviteJanusComponent implements OnInit {

  /** Email input */
  userEmail = '';

  /** Roles */
  roles: (Role & { selected?: boolean })[] = [];

  /** Loaders */
  isRolesLoading = false;

  get canInvite(): boolean {
    return !!this.userEmail?.trim() && this.roles.some(role => !!role.selected);
  }

  /** Confirmation modal */
  confirmationModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: '',
    modalSubDescp: '',
    yesNoBtn: false,
    okBtn: true,
    closeBtn: false,
    status: 'default'
  };

  private getDefaultModalData(): CommonConfirmationModalData {
    return {
      open: false,
      modalDescp: '',
      modalSubDescp: '',
      yesNoBtn: false,
      okBtn: true,
      closeBtn: false,
      status: 'default'
    };
  }

  constructor(
    private securitySvc: SecurityService,
    private context: WorkflowContextService
  ) { }

  ngOnInit(): void {
    this.loadRoles();
  }

  /** Fetch roles */
  loadRoles(): void {
    this.isRolesLoading = true;

    this.securitySvc
      .getRoles(this.context.client.id)
      .subscribe({
        next: roles => {
          this.roles = roles.map(r => ({
            ...r,
            selected: false
          }));
          this.isRolesLoading = false;
        },
        error: () => {
          this.isRolesLoading = false;
          this.showModal(
            'Failed to load roles.',
            'Please try again later.',
            'error'
          );
        }
      });
  }

  /** Invite user */
  submitInvite(emailModel: any): void {
    emailModel.control.markAsTouched();

    const email = this.userEmail?.trim();
    const selectedRoles = this.roles.filter(r => r.selected);

    if (!this.canInvite || selectedRoles.length === 0) {
      return;
    }

    const request = new InviteUserRequest({
      email,
      roles: selectedRoles
    });

    this.securitySvc.inviteUser(request).subscribe({
      next: (res: InviteUserResponse) => {
        if (res?.existingUsers) {
          this.showModal(
            'User already exists',
            res.resultMessage,
            'info'
          );
        } else {
          this.showModal(
            'Invitation sent',
            `An invitation has been sent to ${email}.`,
            'success'
          );
        }
      },
      error: () => {
        this.showModal(
          'Invite failed',
          'Something went wrong while sending the invitation.',
          'error'
        );
      }
    });
  }


  /** Common modal helper */
  private showModal(
    title: string,
    desc: string,
    status: 'success' | 'error' | 'info' | 'default'
  ): void {
    this.confirmationModalData = {
      ...this.getDefaultModalData(),
      open: true,
      modalDescp: title,
      modalSubDescp: desc,
      replaceOkWith: 'OK',
      status
    };
  }

  /** Modal OK */
  handleModalOk(): void {
    this.confirmationModalData = this.getDefaultModalData();

    // reset email field
    this.userEmail = '';

    // reset role selections
    this.roles = this.roles.map(role => ({
      ...role,
      selected: false
    }));
  }


  cancel(): void {
    history.back();
  }
}
